import React from "react";
import classes from "./FooterFourth.module.css";
import { useSelector } from "react-redux";
import {
  FaFacebookF,
  FaXTwitter,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa6"; 
import {
  selectCountries,
  selectSelectedCode,
} from "../../../../../store/redux/country/country-slice";

const FooterFour = () => {
  const countries = useSelector(selectCountries);
  const selectedCode = useSelector(selectSelectedCode);

  const selectedCountry = countries?.[selectedCode];

  return (
    <footer className={classes["footer_four"]}>
      <div className={classes["footer_container"]}>
        
        {/* Left Side: Brand & Country info */}
        <div className={classes["footer_left"]}>
          <div className={classes["country_wrapper"]}>
            <h3>Muradiz {selectedCountry?.countryName || "United States"}</h3>
            {selectedCountry?.flagEmoji && (
              <span className={classes.emoji} aria-hidden="true">
                {selectedCountry.flagEmoji}
              </span>
            )}
          </div>
          {/* Copyright nested neatly here for professional vertical rhythm */}
          <div className={classes["foot_copy_right"]}>
            © {new Date().getFullYear()} Muradiz. All rights reserved.
          </div>
        </div>

        {/* Right Side: Social Media Channels */}
        <div className={classes["footer_right"]}>
          <h3 className={classes["social_heading"]}>Follow Us</h3>
          <div className={classes["social_container"]}>
            <a
              href="https://www.facebook.com/muradizhq"
              target="_blank"
              rel="noopener noreferrer"
              className={`${classes["social_icon"]} ${classes["facebook"]}`}
              aria-label="Follow Muradiz on Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://x.com/muradizhq"
              target="_blank"
              rel="noopener noreferrer"
              className={`${classes["social_icon"]} ${classes["twitter"]}`}
              aria-label="Follow Muradiz on X (Twitter)"
            >
              <FaXTwitter />
            </a>
            <a
              href="https://www.instagram.com/muradizhq"
              target="_blank"
              rel="noopener noreferrer"
              className={`${classes["social_icon"]} ${classes["instagram"]}`}
              aria-label="Follow Muradiz on Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.youtube.com/@Muradizhq"
              target="_blank"
              rel="noopener noreferrer"
              className={`${classes["social_icon"]} ${classes["youtube"]}`}
              aria-label="Subscribe to Muradiz on YouTube"
            >
              <FaYoutube />
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default FooterFour;

// /* eslint-disable jsx-a11y/anchor-has-content */
// import React from "react";
// import classes from "./FooterFourth.module.css";
// import { Link } from "react-router-dom";
// import { useSelector } from "react-redux";
// import {
//   selectCountries,
//   selectSelectedCode,
// } from "../../../../../store/redux/country/country-slice";
// const FooterFour = () => {
//   const countries = useSelector(selectCountries);
//   const selectedCode = useSelector(selectSelectedCode);

//   const selectedCountry = countries?.[selectedCode];
//   return (
//     <div className={classes["footer_four"]}>
//       <section>
//         <div className={classes["footer_container"]}>
//           <div className={classes["footer_inner"]}>
//             <h3>Muradiz {selectedCountry?.countryName || "United States"}</h3>
//             <span className={classes.emoji}>{selectedCountry?.flagEmoji}</span>
//           </div>
//           <div className={classes["footer_inner"]}>
//             <h3>follow us</h3>
//             <a
//               href="https://www.facebook.com/muradizhq"
//               target="_blank"
//               rel="noopener noreferrer"
//               className={`${classes["foot-ico"]} ${classes["social_one"]}`}
//             />
//             <a
//               href="https://x.com/muradizhq"
//               target="_blank"
//               rel="noopener noreferrer"
//               className={`${classes["foot-ico"]} ${classes["social_two"]}`}
//             />
//             <a
//               href="https://www.instagram.com/muradizhq"
//               target="_blank"
//               rel="noopener noreferrer"
//               className={`${classes["foot-ico"]} ${classes["social_three"]}`}
//             />
//             <a
//               href={"https://www.youtube.com/@Muradizhq"}
//               target="_blank"
//               rel="noopener noreferrer"
//               className={`${classes["foot-ico"]} ${classes["social_four"]}`}
//             />
//           </div>
//           <div
//             className={`${classes["footer_inner"]} ${classes["copy-right_main"]}`}
//           >
//             <div className={classes["foot_copy_right"]}>
//               © Muradiz {new Date().getFullYear()}
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default FooterFour;
